<template lang="pug">
  div.m-0.p-0
    form(ref="multiDisplayForm" :action="action_url" method="GET" @submit.prevent="onClick")
      input(type="hidden" name="is_multi_display" :value="data_is_multi_display")
      input(type="hidden" name="design_id" :value="design_id")
      div.d-flex
        button.btn.btn-success.btn-sm.ml-2(type='submit') {{ buttonText }}
        help-tooltip(html-key='heatmapParallel')
    div.d-flex.align-items-center
      UpgradeUpperMaster(v-if="is_upgrade_upper_master_modal", @close-modal="is_upgrade_upper_master_modal = false")
  </template>

<script>
//libs
import UpgradeUpperMaster from "./modals/upgrade_upper_master.vue";

export default {
  props: {
    action_url: {type: String, default: "" },
    is_upper_master: {type: Boolean, default: false },
    is_multi_display: {type: Boolean, default: false },
    heatmap_token: {type: String, default: "" },
    design_id: {type: String, default: "" },
  },
  methods: {
    async onClick(){
      if (!this.is_upper_master){
        this.is_upgrade_upper_master_modal = true
        return
      }
      this.data_is_multi_display = !this.data_is_multi_display
      this.$nextTick(() => {
        this.$refs.multiDisplayForm.submit()
      })
    },
  },
  data(){
    return {
      is_upgrade_upper_master_modal: false,
      data_is_multi_display: false,
    }
  },
  created() {
    this.data_is_multi_display = this.is_multi_display
  },
  computed: {
    buttonText() {
      return this.data_is_multi_display ? '並列表示をやめる' : '並列表示';
    },
  },
  components: {
    UpgradeUpperMaster,
  },
}
</script>

